import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

// NOTE: les types de la base vivent dans un fichier généré unique :
//   src/types/database.ts  (regénérable via `supabase gen types typescript`).
// Le client n'est volontairement PAS encore paramétré avec <Database> :
// activer le typage strict fera remonter des nullités à corriger dans plusieurs
// pages existantes (Shop, Support, Settings, Subscription). À faire dans une
// passe dédiée « typage strict » pour garder ce build vert.
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
})

// Référence de types unique, réexportée pour usage applicatif.
export type { Database } from '../types/database'
